import { createRoute } from '@tanstack/react-router'
import { rootRoute } from './root'
import { LunarsPage } from '../features/lunars/page'

export const lunarsRoute = createRoute({
  path: 'lunars',
  getParentRoute: () => rootRoute,
  component: LunarsPage,
})
